import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    // The full width of the drawer: the open logo (mark + "Waadoo") is wider
    // than the closed drawer, and the drawer clips its overflow.
    width: '100%',
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    // Centres the 36 px mark in the 72 px closed drawer; the open logo starts
    // at the same x, so the mark does not jump when the drawer opens.
    marginLeft: (sidebarConfig.drawerWidthClosed - 36) / 2,
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      {/* The root is the home page (components/home/plugin.tsx). */}
      <Link
        to="/"
        underline="none"
        className={classes.link}
        aria-label="Accueil"
      >
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
